export default __webpack_public_path__ + "static/media/MoodThink.8ec9ee22.png";